import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=2685db5c&scoped=true&lang=pug"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"
import style0 from "./Tab.vue?vue&type=style&index=0&id=2685db5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2685db5c",
  null
  
)

export default component.exports